module.exports = __webpack_public_path__ + "img/cooperative1_logo0.876cb3fe.jpg";